import React, {
  Component
} from "react";
import {
  connect
} from "react-redux";
import _ from "lodash";
import {Rect, Group} from "react-konva";
import {pipeBedSelectElement} from "../../../actions/pipe-bed-actions";
import {renderAccessoryHelper} from "./pipe-accessory-helper";
import {removePipeAccessory} from "../../../actions/floating-tool-pipes-actions";
import ArrowFlowComponent from './flow-arrow-component';
import {PIPE_POSITION_CENTER, PIPE_SIDE_RIGHT} from "../../../lib/types";

const imgUrl = require('../../../media/pipes/PIPE_PITCH_180x48.png');
const fragmentImg = new window.Image();
fragmentImg.src = imgUrl;

class PipeStickComponent extends Component {
  handleOnMouseOver = (e) => {
    if (this.isSelected()) return;
    e.target.to({
      opacity: 1
    })
  };

  handleOnMouseOut = (e) => {
    if (this.isSelected()) return;
    e.target.to({
      opacity: 0
    })
  };
  handleOnMouseClick = (e) => {
    this.props.pipeBedSelectElement(this.props.id);
  };

  renderPipe = () => {
    const fillPatternScale = this.props.pipeOD / 180;
    const pipeDivisionXPos = (this.props.x + (this.props.pipeOD * 0.1));
    const pipeDivisionWidth = this.props.pipeOD - (this.props.pipeOD * 0.2);
    return (<React.Fragment>
        <Rect
          fillPatternImage={fragmentImg}
          width={this.props.pipeOD}
          fillPatternScaleX={fillPatternScale}
          fillPatternScaleY={fillPatternScale}
          height={this.props.length - 2}
          x={this.props.x}
          y={this.props.y + 1}
          rotation={this.props.rotation}
          fillColor={'yellow'}
        />
        <Rect
          x={pipeDivisionXPos}
          y={this.props.y}
          width={pipeDivisionWidth}
          height={1}
          fill={'grey'}
        />
        <Rect
          x={pipeDivisionXPos}
          y={this.props.y + (this.props.length - 1)}
          width={pipeDivisionWidth}
          height={1}
          fill={'grey'}
        />
        <ArrowFlowComponent arrowOrientation={this.props.arrowOrientation} x={0} y={this.props.y + ((this.props.length / 2) - (this.props.pipeOD / 2))}/>
    </React.Fragment>);
  };

  isSelected = () => {
    return _.isEqual(this.props.id, this.props.selected)
  };

  renderAccessories = () => {
    const {id, numberOfPipeRows} = this.props;
    const accessories = this.props.pipeElements.find(e => {
      return _.isEqual(this.props.id, e.id);
    }) || {};

    if (numberOfPipeRows - 1 > id.row && accessories.placeholders && accessories.placeholders.center.right !== null) {
      this.props.removePipeAccessory(id, PIPE_POSITION_CENTER, PIPE_SIDE_RIGHT);
    }

    return renderAccessoryHelper({
      ...this.props.id,
      width: this.props.pipeOD,
      height: this.props.length,
      offSet: this.props.y
    }, accessories);
  };

  render() {
    return (
      <Group>
        {this.renderPipe()}
        {/*pipe stick selection*/}
        <Rect
          x={this.props.x}
          y={this.props.y}
          width={this.props.pipeOD}
          height={this.props.length}
          fill={this.isSelected() ? 'rgba(255, 165,0,0.5)' : 'rgba(255,255,255,0.2)'}
          opacity={this.isSelected() ? 1 : 0}
          onMouseOver={this.handleOnMouseOver}
          onMouseOut={this.handleOnMouseOut}
          onClick={this.handleOnMouseClick}
          stroke={'purple'}
          strokeWidth={.4}
          dash={[3, 3]}
        />
        {this.renderAccessories()}
      </Group>
    );
  }
}

const mapStateToProps = state => {
  return {
    numberOfPipeRows: state.pipeBed.numberOfPipeRows,
    pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
    selected: state.pipeGlobals.contextSelectedPipeElement,
    pipeElements: state.pipeBed.pipeElements,
    x: 0,
    pipeFlowDirection: state.pipeGlobals.pipeFlowDirection
  };
};
export default connect(
  mapStateToProps, {
    pipeBedSelectElement,
    removePipeAccessory
  }
)(PipeStickComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/pipe-stick-component.js